import { useRoutePageContext } from "@components/ui/route-page-context"
import * as m from "@paraglide/messages"

export function CompanyStory() {
  const { locale } = useRoutePageContext()
  return (
    <section
      data-id="company-story"
      className="mx-auto grid h-[100dvh] max-w-[800px] place-content-center p-[2em]"
    >
      <h1 className="my-[1em] text-[length:var(--h2-fontSize)] opacity-0 [animation:fade-in_5s_ease_1_forwards]">
        {m.company_ourCompany_label({}, { locale: locale })}
      </h1>
      <p className="my-[1em] text-[length:min(3em,5vw)] opacity-0 [animation-delay:0.5s] [animation:fade-in_5s_ease_1_forwards]">
        {m.company_ourCompany_pointOne({}, { locale: locale })}
      </p>
      <p className="my-[1em] text-[length:min(3em,5vw)] opacity-0 [animation-delay:1s] [animation:fade-in_5s_ease_1_forwards]">
        {m.company_ourCompany_pointTwo({}, { locale: locale })}
      </p>
      <p className="my-[1em] text-[length:min(3em,5vw)] opacity-0 [animation-delay:3s] [animation:fade-in_5s_ease_1_forwards]">
        {m.company_ourCompany_pointThree({}, { locale: locale })}
      </p>
    </section>
  )
}

export default CompanyStory
